<template>
  <div class="pagina ativa" id="paginaDashboard">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:16px;border-bottom:2px solid #4a5c2f;padding-bottom:10px;">
      <div style="font-size:22px;font-weight:bold;color:#4a5c2f;">Dashboard de Vendas</div>
      <div style="display:flex;gap:8px;">
        <button @click="toggleEditar" :style="{ display: 'inline-flex', alignItems: 'center', gap: '5px', marginTop:0, padding:'8px 18px', fontSize:'13px', background: modoEdicao ? '#27ae60' : '#f39c12' }"><CircleCheck v-if="modoEdicao" :size="14" /><Pencil v-else :size="14" /> {{ modoEdicao ? 'Editando' : 'Editar' }}</button>
        <button @click="exportarPDF" style="margin-top:0;padding:8px 18px;font-size:13px;">Exportar PDF</button>
      </div>
    </div>

    <div class="dash-editor-bar" :class="{ ativo: modoEdicao }">
      <span style="font-size:13px;font-weight:bold;color:#856404;">{{ mensagemBarra }}</span>
      <div style="display:flex;gap:8px;">
        <button @click="salvarLayout" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:7px 16px;font-size:13px;background:#27ae60;"><Save :size="13" /> Salvar Layout</button>
        <button @click="resetarLayout" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:7px 16px;font-size:13px;background:#888;"><RotateCcw :size="13" /> Resetar</button>
        <button @click="toggleEditar" style="display:inline-flex;align-items:center;gap:5px;margin:0;padding:7px 16px;font-size:13px;background:#c0392b;"><X :size="13" /> Fechar</button>
      </div>
    </div>

    <div class="dash-catalog" v-show="modoEdicao">
      <div class="dash-catalog-title" style="display:flex;align-items:center;gap:7px;"><Package :size="15" /> Catálogo de Widgets — clique para ativar/desativar</div>
      <div class="dash-catalog-grid">
        <div v-for="w in layoutOrdenado" :key="'cat-' + w.id" class="dash-catalog-item" :class="{ ativo: w.ativo }" @click="toggleWidget(w.id)">
          <span style="display:inline-flex;"><SquareCheck v-if="w.ativo" :size="15" /><Square v-else :size="15" /></span><span>{{ w.label }}</span>
        </div>
      </div>
    </div>

    <div style="background:white;padding:15px 20px;border-radius:10px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:20px;display:flex;gap:15px;align-items:flex-end;flex-wrap:wrap;">
      <div>
        <label>Mes</label>
        <select v-model="filtroMes" @change="onFiltroChange" style="width:150px;">
          <option value="">Todos</option>
          <option v-for="m in meses" :key="m.v" :value="m.v">{{ m.l }}</option>
        </select>
      </div>
      <div>
        <label>Ano</label>
        <select v-model="filtroAno" @change="onFiltroChange" style="width:120px;">
          <option value="">Todos</option>
          <option value="2025">2025</option>
          <option value="2026">2026</option>
          <option value="2027">2027</option>
        </select>
      </div>
    </div>

    <p v-if="carregando" style="color:#888;text-align:center;padding:20px;">Carregando...</p>

    <div id="dashWidgetsContainer" v-else>
      <div v-for="(w, idx) in layoutOrdenado" :key="w.id" class="dash-widget-wrap" :class="{ editando: modoEdicao }"
           :style="{ display: w.ativo ? '' : 'none', marginBottom: '20px' }"
           draggable="true"
           @dragstart="onDragStart(idx, $event)"
           @dragover.prevent="onDragOver(idx)"
           @dragleave="dragOverIdx = -1"
           @drop.prevent="onDrop(idx)"
           :class2="dragOverIdx === idx ? 'drag-over' : ''"
      >
        <div class="dash-widget-handle" style="display:flex;align-items:center;gap:4px;"><GripVertical :size="13" /> mover</div>
        <div class="dash-move-btns">
          <button class="dash-move-btn" @click="mover(idx, -1)"><ChevronLeft :size="13" /></button>
          <button class="dash-move-btn" @click="mover(idx, 1)"><ChevronRight :size="13" /></button>
        </div>
        <button class="dash-widget-toggle" @click="toggleWidget(w.id)" style="display:inline-flex;align-items:center;gap:4px;"><X :size="12" /> ocultar</button>

        <!-- CARDS RESUMO -->
        <div v-if="w.id === 'w_cards'" class="grid-cards">
          <div class="card"><div class="card-label">Total Vendas</div><div class="card-valor" id="dTotalVendas">{{ qtdVendas }}</div></div>
          <div class="card"><div class="card-label">Valor Total</div><div class="card-valor" id="dValorTotal">{{ fmtBRL(valorTotal) }}</div></div>
          <div class="card"><div class="card-label">Vendedores</div><div class="card-valor" id="dVendedores">{{ qtdVendedores }}</div></div>
          <div class="card"><div class="card-label">Melhor Dia</div><div class="card-valor" id="dMelhorMes" style="font-size:16px;">{{ melhorDiaFmt }}</div></div>
        </div>

        <!-- PROGRESSO DE METAS -->
        <div v-else-if="w.id === 'w_metas'" style="background:white;border-radius:10px;padding:25px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
          <div style="display:flex;align-items:center;gap:8px;font-weight:bold;color:#4a5c2f;font-size:16px;margin-bottom:15px;"><Target :size="17" /> Progresso das Metas</div>
          <div style="margin-bottom:20px;">
            <div v-if="metaGeralValor > 0">
              <div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;margin-bottom:10px;">
                <div class="card"><div class="card-label">Realizado</div><div class="card-valor" style="font-size:18px;color:#4a5c2f;">{{ fmtBRL(valorTotal) }}</div></div>
                <div class="card"><div class="card-label">Meta</div><div class="card-valor" style="font-size:18px;">{{ fmtBRL(metaGeralValor) }}</div></div>
                <div class="card"><div class="card-label">Falta</div><div class="card-valor" style="font-size:18px;" :style="{ color: corMetaGeral }">{{ fmtBRL(faltaMetaGeral) }}</div></div>
              </div>
              <div style="background:#eee;border-radius:10px;height:24px;overflow:hidden;position:relative;">
                <div :style="{ background: corMetaGeral, height: '100%', width: pctMetaGeral + '%', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }">
                  <span style="color:white;font-size:12px;font-weight:bold;">{{ pctMetaGeral.toFixed(1) }}%</span>
                </div>
                <span style="position:absolute;right:8px;top:50%;transform:translateY(-50%);font-size:11px;color:#666;font-weight:bold;">Falta {{ (100 - pctMetaGeral).toFixed(1) }}%</span>
              </div>
            </div>
            <p v-else style="color:#aaa;">Nenhuma meta geral.</p>
          </div>
          <div v-if="metasVendedor.length > 0">
            <div style="font-weight:bold;color:#333;margin:15px 0 12px;">Metas por Vendedor</div>
            <div v-for="m in metasVendedor" :key="m.vendedor" style="border:1px solid #eee;border-radius:10px;padding:15px;margin-bottom:12px;">
              <div style="font-weight:bold;color:#4a5c2f;margin-bottom:10px;">{{ m.vendedor }}</div>
              <div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:10px;margin-bottom:8px;">
                <div class="card"><div class="card-label">Realizado</div><div class="card-valor" style="font-size:16px;color:#4a5c2f;">{{ fmtBRL(m.realizado) }}</div></div>
                <div class="card"><div class="card-label">Meta</div><div class="card-valor" style="font-size:16px;">{{ fmtBRL(m.meta) }}</div></div>
                <div class="card"><div class="card-label">Falta</div><div class="card-valor" style="font-size:16px;" :style="{ color: m.cor }">{{ fmtBRL(m.falta) }}</div></div>
              </div>
              <div style="background:#eee;border-radius:10px;height:18px;overflow:hidden;position:relative;">
                <div :style="{ background: m.cor, height: '100%', width: m.pct + '%', borderRadius: '10px' }"></div>
                <span style="position:absolute;right:6px;top:50%;transform:translateY(-50%);font-size:10px;color:#666;">-{{ (100 - m.pct).toFixed(1) }}%</span>
              </div>
            </div>
          </div>
        </div>

        <!-- VALOR POR DIA -->
        <div v-else-if="w.id === 'w_diario'" style="background:white;border-radius:10px;padding:20px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
          <div style="display:flex;align-items:center;gap:8px;font-weight:bold;color:#4a5c2f;margin-bottom:15px;"><CalendarDays :size="16" /> Valor por Dia</div>
          <canvas ref="graficoMeses"></canvas>
        </div>

        <!-- RANKING GERAL -->
        <div v-else-if="w.id === 'w_ranking'" style="background:white;border-radius:10px;padding:20px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
          <div style="display:flex;align-items:center;gap:8px;font-weight:bold;color:#4a5c2f;margin-bottom:4px;font-size:16px;"><Trophy :size="17" /> Ranking de Vendedores</div>
          <div v-if="ranking.length > 0" style="display:flex;align-items:flex-end;justify-content:center;gap:8px;padding:16px 0 8px;border-bottom:1px solid #f0f0f0;margin-bottom:16px;">
            <div style="display:flex;flex-direction:column;align-items:center;gap:6px;flex:1;" v-if="ranking[1]">
              <Medal :size="26" color="#9CA3AF" />
              <img v-if="fotoDoUsuario(ranking[1].nome)" :src="fotoDoUsuario(ranking[1].nome)" :style="avatarImgStyle(52)" />
              <div v-else :style="avatarStyle(1, 52)">{{ initials(ranking[1].nome) }}</div>
              <div style="font-size:12px;font-weight:bold;color:#333;text-align:center;max-width:90px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ ranking[1].nome.split(' ')[0] }}</div>
              <div style="font-size:11px;color:#4a5c2f;font-weight:bold;">R$ {{ Math.round(ranking[1].v/1000) }}k</div>
              <div style="font-size:10px;color:#888;">{{ ranking[1].q }} venda{{ ranking[1].q !== 1 ? 's' : '' }}</div>
              <template v-if="metaGeralValor > 0">
                <div style="width:70px;background:#eee;border-radius:10px;height:6px;overflow:hidden;"><div :style="{ background: podioCor(ranking[1]), height: '100%', width: podioPct(ranking[1]) + '%', borderRadius: '10px' }"></div></div>
                <div style="font-size:9px;" :style="{ color: podioCor(ranking[1]) }">{{ podioPct(ranking[1]).toFixed(0) }}%</div>
              </template>
            </div>
            <div v-else style="flex:1;"></div>
            <div style="display:flex;flex-direction:column;align-items:center;gap:6px;flex:1;">
              <Medal :size="28" color="#D4A017" />
              <img v-if="fotoDoUsuario(ranking[0].nome)" :src="fotoDoUsuario(ranking[0].nome)" :style="avatarImgStyle(52)" />
              <div v-else :style="avatarStyle(0, 52)">{{ initials(ranking[0].nome) }}</div>
              <div style="font-size:12px;font-weight:bold;color:#333;text-align:center;max-width:90px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ ranking[0].nome.split(' ')[0] }}</div>
              <div style="font-size:11px;color:#4a5c2f;font-weight:bold;">R$ {{ Math.round(ranking[0].v/1000) }}k</div>
              <div style="font-size:10px;color:#888;">{{ ranking[0].q }} venda{{ ranking[0].q !== 1 ? 's' : '' }}</div>
              <template v-if="metaGeralValor > 0">
                <div style="width:70px;background:#eee;border-radius:10px;height:6px;overflow:hidden;"><div :style="{ background: podioCor(ranking[0]), height: '100%', width: podioPct(ranking[0]) + '%', borderRadius: '10px' }"></div></div>
                <div style="font-size:9px;" :style="{ color: podioCor(ranking[0]) }">{{ podioPct(ranking[0]).toFixed(0) }}%</div>
              </template>
            </div>
            <div style="display:flex;flex-direction:column;align-items:center;gap:6px;flex:1;" v-if="ranking[2]">
              <Medal :size="24" color="#B45309" />
              <img v-if="fotoDoUsuario(ranking[2].nome)" :src="fotoDoUsuario(ranking[2].nome)" :style="avatarImgStyle(52)" />
              <div v-else :style="avatarStyle(2, 52)">{{ initials(ranking[2].nome) }}</div>
              <div style="font-size:12px;font-weight:bold;color:#333;text-align:center;max-width:90px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{ ranking[2].nome.split(' ')[0] }}</div>
              <div style="font-size:11px;color:#4a5c2f;font-weight:bold;">R$ {{ Math.round(ranking[2].v/1000) }}k</div>
              <div style="font-size:10px;color:#888;">{{ ranking[2].q }} venda{{ ranking[2].q !== 1 ? 's' : '' }}</div>
              <template v-if="metaGeralValor > 0">
                <div style="width:70px;background:#eee;border-radius:10px;height:6px;overflow:hidden;"><div :style="{ background: podioCor(ranking[2]), height: '100%', width: podioPct(ranking[2]) + '%', borderRadius: '10px' }"></div></div>
                <div style="font-size:9px;" :style="{ color: podioCor(ranking[2]) }">{{ podioPct(ranking[2]).toFixed(0) }}%</div>
              </template>
            </div>
            <div v-else style="flex:1;"></div>
          </div>
          <div v-for="(x, i) in ranking.slice(3)" :key="x.nome" style="display:flex;align-items:center;gap:10px;padding:8px 0;border-bottom:1px solid #f5f5f5;">
            <div style="width:22px;text-align:center;font-weight:bold;color:#888;font-size:13px;">{{ i + 4 }}</div>
            <img v-if="fotoDoUsuario(x.nome)" :src="fotoDoUsuario(x.nome)" :style="avatarImgStyle(36)" />
            <div v-else :style="avatarStyle(i + 3, 36)">{{ initials(x.nome) }}</div>
            <div style="flex:1;min-width:0;">
              <div style="font-size:12px;font-weight:bold;color:#333;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{ x.nome }}</div>
              <div style="display:flex;align-items:center;gap:6px;margin-top:3px;">
                <div style="flex:1;background:#eee;border-radius:10px;height:5px;max-width:120px;overflow:hidden;">
                  <div :style="{ background: podioCor(x), height: '100%', width: (metaGeralValor > 0 ? podioPct(x) : Math.min((x.v/ranking[0].v)*100,100)) + '%', borderRadius: '10px' }"></div>
                </div>
                <div style="font-size:10px;color:#888;">{{ x.q }} venda{{ x.q !== 1 ? 's' : '' }}</div>
              </div>
            </div>
            <div style="font-size:12px;font-weight:bold;color:#4a5c2f;white-space:nowrap;">{{ 'R$ ' + x.v.toLocaleString('pt-BR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) }}</div>
          </div>
        </div>

        <!-- VENDAS POR BEM -->
        <div v-else-if="w.id === 'w_porbem'" style="background:white;border-radius:10px;padding:20px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
          <div style="display:flex;align-items:center;gap:8px;font-weight:bold;color:#4a5c2f;margin-bottom:15px;"><Package :size="16" /> Vendas por BEM/Segmento</div>
          <div v-if="porBemLista.length === 0"><p style="color:#aaa;">Sem dados.</p></div>
          <div v-for="(b, i) in porBemLista" :key="b.nome" style="margin-bottom:10px;">
            <div style="display:flex;justify-content:space-between;font-size:12px;margin-bottom:3px;">
              <span>{{ b.nome }}</span>
              <span :style="{ color: coresBem[i % coresBem.length] }">{{ b.q }} vendas · {{ fmtBRL(b.v) }}</span>
            </div>
            <div style="background:#eee;border-radius:6px;height:14px;"><div :style="{ background: coresBem[i % coresBem.length], height: '100%', width: (valorTotal > 0 ? (b.v/valorTotal*100) : 0) + '%', borderRadius: '6px' }"></div></div>
          </div>
          <canvas ref="graficoBem" style="margin-top:15px;max-height:200px;"></canvas>
        </div>

        <!-- TAXA CANCELAMENTO -->
        <div v-else-if="w.id === 'w_canc'" style="background:white;border-radius:10px;padding:20px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
          <div style="display:flex;align-items:center;gap:8px;font-weight:bold;color:#4a5c2f;margin-bottom:15px;"><TriangleAlert :size="16" /> Taxa de Cancelamento / Estorno</div>
          <div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin-bottom:15px;">
            <div class="card"><div class="card-label">Total Vendas</div><div class="card-valor">{{ totalAll }}</div></div>
            <div class="card"><div class="card-label">Canceladas/Estornadas</div><div class="card-valor" style="color:#c0392b;">{{ canc }}</div></div>
            <div class="card"><div class="card-label">Taxa</div><div class="card-valor" :style="{ color: corCanc }">{{ txCanc }}%</div></div>
          </div>
          <div style="background:#eee;border-radius:10px;height:18px;overflow:hidden;"><div :style="{ background: corCanc, height: '100%', width: Math.min(parseFloat(txCanc),100) + '%', borderRadius: '10px' }"></div></div>
        </div>

        <!-- EVOLUCAO MENSAL -->
        <div v-else-if="w.id === 'w_evolucao'" style="background:white;border-radius:10px;padding:20px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
          <div style="display:flex;align-items:center;gap:8px;font-weight:bold;color:#4a5c2f;margin-bottom:15px;"><TrendingUp :size="16" /> Evolução Mensal Comparativa</div>
          <div style="display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin-bottom:12px;">
            <div class="card"><div class="card-label">{{ mesNome[mesAnteriorNum] }}{{ filtroAno ? ' ' + filtroAno : '' }}</div><div class="card-valor" style="font-size:16px;">{{ fmtBRL(valorTotalAnterior) }}</div></div>
            <div class="card"><div class="card-label">{{ mesNome[mesAtualNum] }}{{ filtroAno ? ' ' + filtroAno : '' }}</div><div class="card-valor" style="font-size:16px;color:#4a5c2f;">{{ fmtBRL(valorTotal) }}</div></div>
            <div class="card"><div class="card-label">Variação</div><div class="card-valor" style="font-size:16px;" :style="{ color: corVariacao }">{{ variacaoFmt }}</div></div>
          </div>
          <canvas ref="graficoEvolucao" style="max-height:160px;"></canvas>
        </div>

        <!-- COMISSOES A PAGAR -->
        <div v-else-if="w.id === 'w_comissoes'" style="background:white;border-radius:10px;padding:20px;box-shadow:0 2px 8px rgba(0,0,0,0.08);">
          <div style="display:flex;align-items:center;gap:8px;font-weight:bold;color:#4a5c2f;margin-bottom:15px;"><Wallet :size="16" /> Comissões a Pagar por Vendedor</div>
          <p v-if="!comissoesCarregadas" style="color:#aaa;text-align:center;">Carregando...</p>
          <div v-else style="overflow-x:auto;">
          <table class="tabela-dash">
            <thead><tr><th>Vendedor</th><th>Total</th><th>Pendente</th><th>Pago</th></tr></thead>
            <tbody>
              <tr v-for="c in comissoesPagar" :key="c.vendedor">
                <td style="padding:8px;font-weight:bold;">{{ c.vendedor }}</td>
                <td style="padding:8px;">{{ fmtBRL(c.total) }}</td>
                <td style="padding:8px;color:#e67e22;font-weight:bold;">{{ fmtBRL(c.pendente) }}</td>
                <td style="padding:8px;color:#27ae60;">{{ fmtBRL(c.pago) }}</td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>

        <!-- VENDEDOR X BEM -->
        <div v-else-if="w.id === 'w_vvbem'" style="background:white;border-radius:10px;padding:20px;box-shadow:0 2px 8px rgba(0,0,0,0.08);overflow-x:auto;">
          <div style="display:flex;align-items:center;gap:8px;font-weight:bold;color:#4a5c2f;margin-bottom:15px;"><BarChart3 :size="16" /> Vendas por Vendedor × BEM</div>
          <table class="tabela-dash">
            <thead><tr><th>Vendedor</th><th v-for="b in bemsUnicos" :key="b">{{ b }}</th></tr></thead>
            <tbody>
              <tr v-for="vn in Object.keys(vendedorXBem)" :key="vn">
                <td style="padding:8px;font-weight:bold;">{{ vn }}</td>
                <td v-for="b in bemsUnicos" :key="b" style="padding:8px;text-align:center;">{{ vendedorXBem[vn][b] || '—' }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- ULTIMAS VENDAS -->
        <div v-else-if="w.id === 'w_recentes'" style="background:white;border-radius:10px;padding:20px;box-shadow:0 2px 8px rgba(0,0,0,0.08);overflow-x:auto;">
          <div style="display:flex;align-items:center;gap:8px;font-weight:bold;color:#4a5c2f;margin-bottom:15px;"><Clock :size="16" /> Últimas Vendas</div>
          <table class="tabela-dash">
            <thead><tr><th>Data</th><th>Vendedor</th><th>Cliente</th><th>BEM</th><th>Valor</th><th>Status</th></tr></thead>
            <tbody>
              <tr v-for="(v, i) in recentes" :key="i">
                <td style="padding:8px;">{{ formatarData(v.dataVenda) }}</td>
                <td style="padding:8px;">{{ v.vendedor }}</td>
                <td style="padding:8px;">{{ v.cliente }}</td>
                <td style="padding:8px;">{{ v.bem }}</td>
                <td style="padding:8px;font-weight:bold;">{{ fmtBRL(v.valor) }}</td>
                <td style="padding:8px;"><span :style="{ background: statusCor(v.status), color: 'white', padding: '2px 8px', borderRadius: '10px', fontSize: '11px' }">{{ v.status }}</span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, apiPublicGet, getSession } from '../api'
import {
  CircleCheck, Pencil, Save, RotateCcw, X, Package, SquareCheck, Square, GripVertical,
  ChevronLeft, ChevronRight, Target, CalendarDays, Trophy, Medal, TriangleAlert,
  TrendingUp, Wallet, BarChart3, Clock
} from 'lucide-vue-next'

const WIDGETS_PADRAO = [
  { id: 'w_cards', label: 'Cards Resumo', ativo: true, ordem: 0 },
  { id: 'w_metas', label: 'Progresso de Metas', ativo: true, ordem: 1 },
  { id: 'w_diario', label: 'Valor por Dia', ativo: true, ordem: 2 },
  { id: 'w_ranking', label: 'Ranking Geral', ativo: true, ordem: 3 },
  { id: 'w_porbem', label: 'Vendas por BEM', ativo: true, ordem: 4 },
  { id: 'w_canc', label: 'Taxa Cancelamento/Estorno', ativo: true, ordem: 5 },
  { id: 'w_evolucao', label: 'Evolução Mensal Comparativa', ativo: true, ordem: 6 },
  { id: 'w_comissoes', label: 'Comissões a Pagar', ativo: true, ordem: 7 },
  { id: 'w_vvbem', label: 'Vendedor × BEM', ativo: true, ordem: 8 },
  { id: 'w_recentes', label: 'Últimas Vendas', ativo: true, ordem: 9 }
]

const CORES_RANK = ['#f39c12', '#95a5a6', '#cd6133', '#4a5c2f', '#3498db', '#8e44ad', '#e74c3c', '#16a085', '#e67e22', '#2ecc71']

export default {
  name: 'PaginaDashboard',
  components: {
    CircleCheck, Pencil, Save, RotateCcw, X, Package, SquareCheck, Square, GripVertical,
    ChevronLeft, ChevronRight, Target, CalendarDays, Trophy, Medal, TriangleAlert,
    TrendingUp, Wallet, BarChart3, Clock
  },
  data() {
    const hoje = new Date()
    return {
      meses: [
        { v: '01', l: 'Jan' }, { v: '02', l: 'Fev' }, { v: '03', l: 'Mar' }, { v: '04', l: 'Abr' },
        { v: '05', l: 'Mai' }, { v: '06', l: 'Jun' }, { v: '07', l: 'Jul' }, { v: '08', l: 'Ago' },
        { v: '09', l: 'Set' }, { v: '10', l: 'Out' }, { v: '11', l: 'Nov' }, { v: '12', l: 'Dez' }
      ],
      mesNome: ['', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      coresBem: ['#4a5c2f', '#27ae60', '#f39c12', '#3498db', '#8e44ad', '#e74c3c'],
      filtroMes: String(hoje.getMonth() + 1).padStart(2, '0'),
      filtroAno: String(hoje.getFullYear()),
      carregando: true,
      todasVendas: [],
      metas: [],
      usuarios: [],
      logoUrl: '',
      comissoesPagar: [],
      comissoesCarregadas: false,
      layout: WIDGETS_PADRAO.map(w => ({ ...w })),
      modoEdicao: false,
      mensagemBarra: 'Modo Edição — arraste os widgets ou use as setas para reordenar',
      dragIdx: -1,
      dragOverIdx: -1,
      graficoMesesInst: null,
      graficoBemInst: null,
      graficoEvolucaoInst: null
    }
  },
  computed: {
    ehAdmin() { return getSession().perfil === 'admin' },
    nomeUsuario() { return getSession().nome },
    layoutOrdenado() { return this.layout.slice().sort((a, b) => a.ordem - b.ordem) },
    vendasEscopo() {
      return this.ehAdmin ? this.todasVendas : this.todasVendas.filter(x => x.vendedor === this.nomeUsuario)
    },
    vendasFiltradas() {
      let v = this.vendasEscopo
      if (this.filtroMes) v = v.filter(x => (x.dataVenda || '').substring(5, 7) === this.filtroMes)
      if (this.filtroAno) v = v.filter(x => (x.dataVenda || '').substring(0, 4) === this.filtroAno)
      return v
    },
    mesAtualNum() { return parseInt(this.filtroMes) || (new Date()).getMonth() + 1 },
    anoAtualNum() { return parseInt(this.filtroAno) || (new Date()).getFullYear() },
    mesAnteriorNum() { return this.mesAtualNum === 1 ? 12 : this.mesAtualNum - 1 },
    anoAnteriorNum() { return this.mesAtualNum === 1 ? this.anoAtualNum - 1 : this.anoAtualNum },
    vendasAnteriores() {
      const mAnt = String(this.mesAnteriorNum).padStart(2, '0')
      const aAnt = String(this.anoAnteriorNum)
      return this.vendasEscopo.filter(x => (x.dataVenda || '').substring(5, 7) === mAnt && (x.dataVenda || '').substring(0, 4) === aAnt)
    },
    qtdVendas() { return this.vendasFiltradas.filter(x => !x.isFilha).length },
    valorTotal() { return this.vendasFiltradas.reduce((s, x) => s + (x.valor || 0), 0) },
    valorTotalAnterior() { return this.vendasAnteriores.reduce((s, x) => s + (x.valor || 0), 0) },
    qtdVendedores() {
      const vu = {}
      this.vendasFiltradas.forEach(x => { if (!x.isFilha) vu[x.vendedor] = true })
      return Object.keys(vu).length
    },
    porDia() {
      const pd = {}
      this.vendasFiltradas.forEach(x => { const d = (x.dataVenda || '').substring(0, 10); if (d) pd[d] = (pd[d] || 0) + (x.valor || 0) })
      return pd
    },
    diasOrdenados() { return Object.keys(this.porDia).sort() },
    melhorDiaFmt() {
      const dias = this.diasOrdenados
      if (dias.length === 0) return '--'
      const md = dias.reduce((a, b) => (this.porDia[a] > this.porDia[b] ? a : b))
      return md.split('-').reverse().join('/')
    },
    totalAll() { return this.vendasFiltradas.filter(v => !v.isFilha).length },
    canc() { return this.vendasFiltradas.filter(v => !v.isFilha && (v.status === 'Cancelada' || v.status === 'Estornada')).length },
    txCanc() { return this.totalAll > 0 ? ((this.canc / this.totalAll) * 100).toFixed(1) : '0' },
    corCanc() { const t = parseFloat(this.txCanc); return t >= 20 ? '#c0392b' : t >= 10 ? '#f39c12' : '#27ae60' },
    porBem() {
      const pb = {}
      this.vendasFiltradas.forEach(v => { if (!v.isFilha) { const b = v.bem || 'Outros'; if (!pb[b]) pb[b] = { q: 0, v: 0 }; pb[b].q++; pb[b].v += v.valor || 0 } })
      return pb
    },
    porBemLista() {
      return Object.keys(this.porBem).sort((a, b) => this.porBem[b].v - this.porBem[a].v).map(nome => ({ nome, q: this.porBem[nome].q, v: this.porBem[nome].v }))
    },
    ranking() {
      const rk = {}
      this.vendasFiltradas.forEach(x => { if (!x.isFilha) { const n = x.vendedor || '?'; if (!rk[n]) rk[n] = { q: 0, v: 0 }; rk[n].q++; rk[n].v += x.valor || 0 } })
      return Object.keys(rk).map(nome => ({ nome, q: rk[nome].q, v: rk[nome].v })).sort((a, b) => b.v - a.v)
    },
    vendedorXBem() {
      const vxb = {}
      this.vendasFiltradas.forEach(v => { if (!v.isFilha) { const vn = v.vendedor || '?'; const b = v.bem || 'Outros'; if (!vxb[vn]) vxb[vn] = {}; vxb[vn][b] = (vxb[vn][b] || 0) + 1 } })
      return vxb
    },
    bemsUnicos() {
      const s = {}
      this.vendasFiltradas.forEach(v => { if (!v.isFilha) s[v.bem || 'Outros'] = true })
      return Object.keys(s).sort()
    },
    recentes() {
      return this.vendasFiltradas.slice().filter(v => !v.isFilha).sort((a, b) => (b.dataVenda || '').localeCompare(a.dataVenda || '')).slice(0, 8)
    },
    variacaoFmt() {
      if (this.valorTotalAnterior <= 0) return '--'
      const pct = ((this.valorTotal - this.valorTotalAnterior) / this.valorTotalAnterior) * 100
      return (pct >= 0 ? '▲' : '▼') + Math.abs(pct).toFixed(1) + '%'
    },
    corVariacao() {
      if (this.valorTotalAnterior <= 0) return '#c0392b'
      return (this.valorTotal - this.valorTotalAnterior) >= 0 ? '#27ae60' : '#c0392b'
    },
    metaGeral() {
      return this.metas.slice().reverse().find(m => parseInt(m.mes) === parseInt(this.filtroMes) && parseInt(m.ano) === parseInt(this.filtroAno) && m.tipo === 'geral')
    },
    metaGeralValor() { return this.metaGeral ? parseFloat(this.metaGeral.meta) : 0 },
    pctMetaGeral() { return this.metaGeralValor > 0 ? Math.min((this.valorTotal / this.metaGeralValor) * 100, 100) : 0 },
    faltaMetaGeral() { return Math.max(this.metaGeralValor - this.valorTotal, 0) },
    corMetaGeral() { return this.pctMetaGeral >= 100 ? '#27ae60' : this.pctMetaGeral >= 70 ? '#f39c12' : '#e74c3c' },
    metasVendedor() {
      const mv = this.metas.filter(m => parseInt(m.mes) === parseInt(this.filtroMes) && parseInt(m.ano) === parseInt(this.filtroAno) && m.tipo === 'vendedor')
      return mv.map(m => {
        let rl = 0
        this.vendasFiltradas.forEach(x => { if (x.vendedor === m.vendedor) rl += x.valor || 0 })
        const mV = parseFloat(m.meta) || 0
        const pV = mV > 0 ? Math.min((rl / mV) * 100, 100) : 0
        const fV = Math.max(mV - rl, 0)
        const cV = pV >= 100 ? '#27ae60' : pV >= 70 ? '#f39c12' : '#e74c3c'
        return { vendedor: m.vendedor, realizado: rl, meta: mV, falta: fV, pct: pV, cor: cV }
      })
    }
  },
  watch: {
    layoutOrdenado() { this.$nextTick(this.renderGraficos) },
    carregando(v) { if (!v) this.$nextTick(this.renderGraficos) }
  },
  created() {
    this.carregar()
  },
  methods: {
    fmtBRL(v) { return 'R$ ' + (parseFloat(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) },
    formatarData(d) {
      if (!d) return ''
      const p = d.substring(0, 10).split('-')
      return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : d
    },
    statusCor(s) { return s === 'Cancelada' ? '#c0392b' : s === 'Contemplada' ? '#27ae60' : s === 'Transferida' ? '#f39c12' : '#4a5c2f' },
    initials(nome) { const p = (nome || '').trim().split(' '); return p.length > 1 ? p[0][0] + p[p.length - 1][0] : (nome || '').substring(0, 2) },
    fotoDoUsuario(nome) {
      const u = this.usuarios.find(x => x.nome === nome)
      return (u && u.foto) || ''
    },
    avatarStyle(pos, size) {
      const bg = CORES_RANK[pos % CORES_RANK.length]
      return {
        width: size + 'px', height: size + 'px', borderRadius: '50%', background: bg,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: (size * 0.33) + 'px', fontWeight: 'bold', color: 'white', flexShrink: '0',
        border: '3px solid rgba(255,255,255,0.4)'
      }
    },
    avatarImgStyle(size) {
      return { width: size + 'px', height: size + 'px', borderRadius: '50%', objectFit: 'cover', flexShrink: '0', border: '3px solid rgba(255,255,255,0.4)' }
    },
    podioPct(p) { return this.metaGeralValor > 0 ? Math.min((p.v / this.metaGeralValor) * 100, 100) : 0 },
    podioCor(p) { const pct = this.podioPct(p); return pct >= 100 ? '#27ae60' : pct >= 70 ? '#f39c12' : '#e74c3c' },
    async carregar() {
      this.carregando = true
      const [rv, rm, rc, rl, ru] = await Promise.all([
        apiGet('vendas/com-calculo'),
        apiGet('metas/listar'),
        apiGet('pagamentos/listar'),
        apiGet('config/get', { chave: 'DASHBOARD_LAYOUT' }),
        apiGet('usuarios/listar-admin')
      ])
      if (rv.sucesso) this.todasVendas = rv.vendas
      if (rm.sucesso) this.metas = rm.metas
      if (ru.sucesso) this.usuarios = ru.usuarios
      apiPublicGet('config/logo-publico', { empresa: 'm-consorcios' }).then(r => { if (r.sucesso && r.valor) this.logoUrl = r.valor })
      if (rc.sucesso) {
        const agg = {}
        rc.pagamentos.forEach(p => {
          const vn = p.vendedor || '--'
          if (!agg[vn]) agg[vn] = { total: 0, pendente: 0, pago: 0 }
          const v = parseFloat(p.comissaoLiquido) || 0
          agg[vn].total += v
          if ((p.statusPagamento || 'pendente').toLowerCase() === 'pendente') agg[vn].pendente += v
          else agg[vn].pago += v
        })
        this.comissoesPagar = Object.keys(agg).sort().map(vendedor => ({ vendedor, ...agg[vendedor] }))
      }
      this.comissoesCarregadas = true
      if (rl.sucesso && rl.valor) {
        try { this.layout = JSON.parse(rl.valor) } catch (e) { /* mantem padrao */ }
      }
      this.carregando = false
    },
    onFiltroChange() {
      this.$nextTick(this.renderGraficos)
    },
    toggleEditar() {
      this.modoEdicao = !this.modoEdicao
    },
    toggleWidget(id) {
      const w = this.layout.find(x => x.id === id)
      if (w) w.ativo = !w.ativo
    },
    mover(idx, dir) {
      const arr = this.layoutOrdenado
      const alvo = idx + dir
      if (alvo < 0 || alvo >= arr.length) return
      const tmp = arr[idx].ordem
      arr[idx].ordem = arr[alvo].ordem
      arr[alvo].ordem = tmp
    },
    onDragStart(idx) { this.dragIdx = idx },
    onDragOver(idx) { if (this.dragIdx !== -1 && this.dragIdx !== idx) this.dragOverIdx = idx },
    onDrop(idx) {
      this.dragOverIdx = -1
      if (this.dragIdx === -1 || this.dragIdx === idx) return
      const arr = this.layoutOrdenado
      const moved = arr.splice(this.dragIdx, 1)[0]
      arr.splice(idx, 0, moved)
      arr.forEach((w, i) => { w.ordem = i })
      this.dragIdx = -1
    },
    async salvarLayout() {
      await apiPost('config/set', { chave: 'DASHBOARD_LAYOUT', valor: JSON.stringify(this.layoutOrdenado) })
      const orig = this.mensagemBarra
      this.mensagemBarra = 'Layout salvo!'
      setTimeout(() => { this.mensagemBarra = orig }, 2000)
    },
    resetarLayout() {
      if (!confirm('Resetar para o layout padrão?')) return
      this.layout = WIDGETS_PADRAO.map(w => ({ ...w }))
    },
    renderGraficos() {
      if (typeof window.Chart === 'undefined') return
      const Chart = window.Chart
      // Vue 3 exposes refs inside v-for as arrays; normalize to the canvas element.
      const canvasRef = ref => Array.isArray(ref) ? ref[0] : ref
      if (this.graficoMesesInst) { this.graficoMesesInst.destroy(); this.graficoMesesInst = null }
      const canvasMeses = canvasRef(this.$refs.graficoMeses)
      if (canvasMeses) {
        const dias = this.diasOrdenados
        this.graficoMesesInst = new Chart(canvasMeses.getContext('2d'), {
          type: 'bar',
          data: { labels: dias.map(d => d.split('-').reverse().join('/')), datasets: [{ label: 'Valor', data: dias.map(d => this.porDia[d]), backgroundColor: '#4a5c2f', borderRadius: 5 }] },
          options: { responsive: true, plugins: { legend: { display: false } }, scales: { y: { beginAtZero: true, ticks: { callback: val => 'R$ ' + val.toLocaleString('pt-BR') } } } }
        })
      }
      if (this.graficoBemInst) { this.graficoBemInst.destroy(); this.graficoBemInst = null }
      const canvasBem = canvasRef(this.$refs.graficoBem)
      if (canvasBem) {
        const bemK = Object.keys(this.porBem)
        this.graficoBemInst = new Chart(canvasBem.getContext('2d'), {
          type: 'doughnut',
          data: { labels: bemK, datasets: [{ data: bemK.map(b => this.porBem[b].q), backgroundColor: this.coresBem.slice(0, bemK.length) }] },
          options: { responsive: true, plugins: { legend: { position: 'bottom' } } }
        })
      }
      if (this.graficoEvolucaoInst) { this.graficoEvolucaoInst.destroy(); this.graficoEvolucaoInst = null }
      const canvasEvolucao = canvasRef(this.$refs.graficoEvolucao)
      if (canvasEvolucao) {
        this.graficoEvolucaoInst = new Chart(canvasEvolucao.getContext('2d'), {
          type: 'bar',
          data: { labels: [this.mesNome[this.mesAnteriorNum], this.mesNome[this.mesAtualNum]], datasets: [{ label: 'Valor', data: [this.valorTotalAnterior, this.valorTotal], backgroundColor: ['#aaa', '#4a5c2f'], borderRadius: 8 }] },
          options: { responsive: true, indexAxis: 'y', plugins: { legend: { display: false } }, scales: { x: { beginAtZero: true, ticks: { callback: v => 'R$ ' + v.toLocaleString('pt-BR') } } } }
        })
      }
    },
    exportarPDF() {
      const per = (this.filtroMes ? this.mesNome[parseInt(this.filtroMes)] : 'Todos') + (this.filtroAno ? ' / ' + this.filtroAno : '')
      const imgTag = this.logoUrl ? '<img src="' + this.logoUrl + '" style="max-height:60px;max-width:120px;object-fit:contain;margin-bottom:6px;display:block;" />' : ''
      let metasHtml = ''
      if (this.metaGeralValor > 0) {
        metasHtml += '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-bottom:10px;"><div class="card"><div class="card-label">Realizado</div><div class="card-valor" style="font-size:18px;color:#4a5c2f;">' + this.fmtBRL(this.valorTotal) + '</div></div><div class="card"><div class="card-label">Meta</div><div class="card-valor" style="font-size:18px;">' + this.fmtBRL(this.metaGeralValor) + '</div></div><div class="card"><div class="card-label">Falta</div><div class="card-valor" style="font-size:18px;color:' + this.corMetaGeral + ';">' + this.fmtBRL(this.faltaMetaGeral) + '</div></div></div><div style="background:#eee;border-radius:10px;height:24px;overflow:hidden;position:relative;"><div style="background:' + this.corMetaGeral + ';height:100%;width:' + this.pctMetaGeral + '%;border-radius:10px;display:flex;align-items:center;justify-content:center;"><span style="color:white;font-size:12px;font-weight:bold;">' + this.pctMetaGeral.toFixed(1) + '%</span></div></div>'
      } else {
        metasHtml += '<p style="color:#aaa;">Nenhuma meta geral.</p>'
      }
      if (this.metasVendedor.length > 0) {
        metasHtml += '<div style="font-weight:bold;color:#333;margin:15px 0 12px;">Metas por Vendedor</div>'
        this.metasVendedor.forEach(m => {
          metasHtml += '<div style="border:1px solid #eee;border-radius:10px;padding:15px;margin-bottom:12px;"><div style="font-weight:bold;color:#4a5c2f;margin-bottom:10px;">' + m.vendedor + '</div><div style="display:grid;grid-template-columns:repeat(3,1fr);gap:10px;margin-bottom:8px;"><div class="card"><div class="card-label">Realizado</div><div class="card-valor" style="font-size:16px;color:#4a5c2f;">' + this.fmtBRL(m.realizado) + '</div></div><div class="card"><div class="card-label">Meta</div><div class="card-valor" style="font-size:16px;">' + this.fmtBRL(m.meta) + '</div></div><div class="card"><div class="card-label">Falta</div><div class="card-valor" style="font-size:16px;color:' + m.cor + ';">' + this.fmtBRL(m.falta) + '</div></div></div><div style="background:#eee;border-radius:10px;height:18px;overflow:hidden;"><div style="background:' + m.cor + ';height:100%;width:' + m.pct + '%;border-radius:10px;"></div></div></div>'
        })
      }
      const rankingRows = this.ranking.map((x, i) => '<tr><td style="padding:8px 10px;border-bottom:1px solid #eee;">' + (i + 1) + '</td><td style="padding:8px 10px;border-bottom:1px solid #eee;">' + x.nome + '</td><td style="padding:8px 10px;border-bottom:1px solid #eee;">' + x.q + '</td><td style="padding:8px 10px;border-bottom:1px solid #eee;">' + this.fmtBRL(x.v) + '</td></tr>').join('')
      const h = '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Dashboard ' + per + '</title><style>*{box-sizing:border-box;margin:0;padding:0}body{font-family:Segoe UI,Arial;background:#f5f5f0;padding:24px}.card{background:white;border-radius:10px;padding:16px;text-align:center;box-shadow:0 2px 6px rgba(0,0,0,.08)}.card-valor{font-size:22px;font-weight:bold;color:#4a5c2f;margin-top:6px}.card-label{font-size:11px;color:#888;text-transform:uppercase}.g4{display:grid;grid-template-columns:repeat(4,1fr);gap:14px;margin-bottom:20px}h2{color:#4a5c2f;font-size:16px;margin:20px 0 12px}table{width:100%;border-collapse:collapse;font-size:13px;background:white;border-radius:10px;overflow:hidden}th{background:#4a5c2f;color:white;padding:10px;text-align:left}td{padding:8px 10px;border-bottom:1px solid #eee}.hd{display:flex;justify-content:space-between;align-items:center;margin-bottom:24px;padding-bottom:16px;border-bottom:2px solid #4a5c2f}.ht{font-size:22px;font-weight:800;color:#4a5c2f}.hs{font-size:13px;color:#888;margin-top:4px}@media print{body{padding:8px}}</style></head><body><div class="hd"><div>' + imgTag + '<div class="ht">Dashboard de Vendas</div><div class="hs">Periodo: ' + per + ' | Gerado: ' + new Date().toLocaleString('pt-BR') + '</div></div></div><div class="g4"><div class="card"><div class="card-label">Vendas</div><div class="card-valor">' + document.getElementById('dTotalVendas').innerText + '</div></div><div class="card"><div class="card-label">Valor</div><div class="card-valor">' + document.getElementById('dValorTotal').innerText + '</div></div><div class="card"><div class="card-label">Vendedores</div><div class="card-valor">' + document.getElementById('dVendedores').innerText + '</div></div><div class="card"><div class="card-label">Melhor Dia</div><div class="card-valor" style="font-size:15px;">' + document.getElementById('dMelhorMes').innerText + '</div></div></div><h2>Metas</h2>' + metasHtml + '<h2>Ranking</h2><table><thead><tr><th>#</th><th>Vendedor</th><th>Vendas</th><th>Valor</th></tr></thead><tbody>' + rankingRows + '</tbody></table></body></html>'
      const blob = new Blob([h], { type: 'text/html' })
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = 'Dashboard_' + per.replace(/\s/g, '_').replace('/', '_') + '.html'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    }
  }
}
</script>
